// ---------------------------------------------------------
//  Mobile menu
// ---------------------------------------------------------
const mobileNavBtn = document.getElementById("mobile-nav");

if(mobileNavBtn) {

    mobileNavBtn.addEventListener("click", (e, i) => {
        mobileNavBtn.classList.toggle("open");
    })
}
// ---------------------------------------------------------
//  Back to top / Scrollspy
// ---------------------------------------------------------
const menu = document.getElementById("mainNav");
const menuItems = menu.querySelectorAll('.nav-link');
const bttBtn = document.getElementById("back-to-top");
const scroll = () => {
    const menuTargets = Array.from(document.querySelectorAll(".menuTarget"));
    const elements = menuTargets.filter(el => el.getBoundingClientRect().top <= 150);
    let element = elements[elements.length - 1];

    if(document.documentElement.scrollHeight <= window.scrollY + document.documentElement.clientHeight){
        element = document.getElementById(Array.from(menuItems)[menuItems.length - 1].dataset.target);
    }

    if(element.menuItem && !element.menuItem.classList.contains('active')){
        const activeItem = menu.querySelector('.active');
        if(activeItem){
            activeItem.classList.remove('active');
        }
        element.menuItem.classList.add('active');
    }

    window.scrollY > 100 ? menu.classList.add("navbar-shrink") : menu.classList.remove("navbar-shrink");
    window.scrollY > 500 ? bttBtn.style.opacity = 1 : bttBtn.style.opacity = 0;
}

bttBtn.style.transition = "opacity 1s";
menuItems.forEach((item, iterator) => {
    let element = document.getElementById(item.dataset.target);
    if(element){
        element.classList.add('menuTarget');
        element.menuItem = item;
    }
})

window.onscroll = () => scroll();

document.addEventListener('DOMContentLoaded',
    () => {
        scroll();
    }, {once: true}
)
